/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Api_Errors_Verwerkersovereenkomst_RequiredInputs */

const nl_import_api_errors_verwerkersovereenkomst_required = /** @type {(inputs: Import_Api_Errors_Verwerkersovereenkomst_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerkersovereenkomst is vereist. Deze wordt via Kennisnet door je scholenstichting ondertekend. Al gebeurd? Laat het ons weten via Help.`)
};

/**

* @param {Import_Api_Errors_Verwerkersovereenkomst_RequiredInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const import_api_errors_verwerkersovereenkomst_required = /** @type {((inputs?: Import_Api_Errors_Verwerkersovereenkomst_RequiredInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Api_Errors_Verwerkersovereenkomst_RequiredInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_import_api_errors_verwerkersovereenkomst_required(inputs)
});
export { import_api_errors_verwerkersovereenkomst_required as "import.api_errors.verwerkersovereenkomst_required" }